const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

export function resizeWindow(rect, edge, dx, dy, area, minWidth = 540) {
  const left = 8, top = 58, right = area.width - 8, bottom = area.height - 8;
  let {x, y, width, height} = rect;
  const minW = Math.min(minWidth, right - left);
  const minH = Math.min(300, bottom - top);
  if (edge.includes('e')) width = clamp(width + dx, Math.min(minW, right - x), right - x);
  if (edge.includes('s')) height = clamp(height + dy, Math.min(minH, bottom - y), bottom - y);
  if (edge.includes('w')) { const end = x + width; x = clamp(x + dx, left, end - minW); width = end - x; }
  if (edge.includes('n')) { const end = y + height; y = clamp(y + dy, top, end - minH); height = end - y; }
  return {x, y, width, height};
}
